import React from "react";
import styled from "styled-components";
import { Box, FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";
import GreyBox from "./GreyBox";

function MiddleSection() {
  return (
    <Wrapper>
      <OnlyWebContent>
        <Heading variant="heading3">
          We're excited to announce the launch of our health newsletter.
        </Heading>
        <ContentText variant="paragraph1">
          We wanted to give you a safe place to get factual information about
          anything and everything to do with health, nutrition, exercise, and so
          much more!
        </ContentText>
      </OnlyWebContent>
      <GreyBox />
    </Wrapper>
  );
}

export default MiddleSection;

const Wrapper = styled(FlexDiv)`
  flex-direction: column;
  gap: 32px;
`;

const Heading = styled(Typography)`
  line-height: 44px;
  color: #282828;
  font-size: 40px;
  font-family: var(--forum);
  font-style: normal;
  letter-spacing: 0px;
  font-weight: 400;

  @media only screen and (max-width: 600px) {
    color: #282828;
    text-align: center;
    font-size: 32px;
    line-height: 35x;
    font-style: normal;
  }
`;

const ContentText = styled(Typography)`
  color: #293056;
  font-size: 14px;
  font-family: var(--mori);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0px;
`;

const OnlyWebContent = styled(FlexDiv)`
  flex-direction: column;
  gap: 16px;
  @media only screen and (max-width: 600px) {
    display: none;
    gap: 12px;
  }
`;
